
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns797c597e5dec9b3e831090c63e14d8dcen from './en.yaml'
            i18n.addResourceBundle('en', '797c597e5dec9b3e831090c63e14d8dc', flattenObject(ns797c597e5dec9b3e831090c63e14d8dcen), true, true);
        
        export default '797c597e5dec9b3e831090c63e14d8dc';
    